<script>
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'

  import {mapGetters} from 'vuex'

  import {cloneDeep} from 'lodash'

  export default {
    data () {
      return {
        intervalSearch: null,
        notificacoes: [],
        mostrarModalNotificacao: false,
        notificacao: {
          notificacao: {}
        }
      }
    },
    mounted () {
      this.buscarNotificacoes()
      const vm = this
      // Buscar novas notificações a cada 1 minuto
      this.intervalSearch = setInterval(() => {
        vm.buscarNotificacoes()
      }, 60 * 1000)
    },
    computed: {
      ...mapGetters(['isLogged']),
      notificacoesNaoVisualizadas () {
        return this.notificacoes.filter(item => item.enviada_em && !item.visualizada_em)
      },
      notificacoesNaoAbertas () {
        return this.notificacoes.filter(item => !item.visualizada_em || (item.visualizada_em && !item.aberta_em))
      }
    },
    watch: {
      isLogged: function (newValue) {
        if (!newValue) {
          clearTimeout(this.intervalSearch)
        }
      }
    },
    methods: {
      buscarNotificacoes () {
        this.notificacoes.splice(0)
        restfulService.get('usuario', 'home-notificacoes')
          .then(response => {
            if (response.length) {
              this.notificacoes = [...this.notificacoes, ...response]
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      marcarTodasComoLida () {
        let notificacoes = this.notificacoes.map(item => item.id)
        if (notificacoes.length) {
          let data = {notificacoes: notificacoes}
          restfulService.put('usuario_notificacao', 'visualizar-todas', null, data)
            .then(response => {
              this.notificacoes.forEach(item => {
                item.visualizada_em = response.visualizada_em
              })
              notifyService.success({
                message: 'Todas as notificações foram marcadas como "Visualizada"'
              })
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          notifyService.warning({
            title: 'Atenção',
            message: 'Não existem nofificação para ler'
          })
        }
      },
      mostrarNotificacao (item) {
        this.notificacao = cloneDeep(item)
        if (!item.visualizada_em && !item.aberta_em) {
          restfulService.put('usuario_notificacao', 'visualizar', item.id)
            .then(response => {
              item.visualizada_em = response.visualizada_em
              this.notificacao.visualizada_em = response.visualizada_em
              this.mostrarModalNotificacao = true
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          this.mostrarModalNotificacao = true
        }
      },
      removerNotificacao (item) {
        restfulService.put('usuario_notificacao', 'abrir', item.id)
          .then(response => {
            item.aberta_em = response.aberta_em
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    beforeDestroy () {
      if (!this.isLogged) {
        clearTimeout(this.intervalSearch)
      }
    }
  }
</script>

<template>
    <div class="notifications">
        <nav class="menu-icons">
            <v-menu offset-y
                    max-width="340px"
                    :close-on-content-click="false"
                    :fixed="true"
                    z-index="190">
                <div class="item-icon" slot="activator">
                    <i class="far fa-bell"></i>
                    <span class="badge-notify" v-if="notificacoesNaoVisualizadas.length > 0">{{notificacoesNaoVisualizadas.length}}</span>
                </div>
                <v-card class="notificacoes-card">
                    <div class="notificacoes-header">
                        <h4 class="notificacoes-header-title">Notificações</h4>
                        <a @click="marcarTodasComoLida" class="notificacoes-header-icon" title="Marcar todas com Visualizada">
                            <i class="fas fa-check"></i>
                        </a>
                    </div>
                    <v-list class="notificacoes-lista" two-line v-if="notificacoesNaoAbertas.length">
                        <template v-for="(item, index) in notificacoesNaoAbertas">
                            <v-list-tile :key="item.title"
                                         class="notificacoes-lista-item"
                                         v-bind:class="{'notificacoes-item-visualizado' : !item.visualizada_em}"
                                         subheader
                                         three-line
                                         ripple>
                                <v-list-tile-content
                                        @click="mostrarNotificacao(item)">
                                    <v-list-tile-title>{{ item.notificacao.titulo }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ item.notificacao.mensagem }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action :title="item.enviada_em | dateTimeEnToBr">
                                    <v-list-tile-action-text>
                                        {{ item.enviada_em | timeEnToBr }}
                                    </v-list-tile-action-text>
                                </v-list-tile-action>
                                <a class="item-lista-remover"
                                   @click="removerNotificacao(item)">
                                    <i class="fas fa-times"></i>
                                </a>
                            </v-list-tile>
                            <v-divider v-if="index + 1 < notificacoesNaoAbertas.length"
                                       :key="index"/>
                        </template>
                    </v-list>
                    <div v-if="!notificacoesNaoAbertas.length" class="notificacoes-lista-vazia">Não existem
                        notificações
                    </div>
                    <router-link class="notificacoes-todos" :to="{name: 'notificacoes'}">
                        Todas notificações
                    </router-link>
                </v-card>
            </v-menu>
            <div class="item-icon" v-if="false">
                <i class="far fa-comment"></i>
                <span class="badge-notify" v-if="mensagens.length > 0">{{mensagens.length}}</span>
            </div>
            <div class="item-icon" v-if="false">
                <i class="far fa-calendar-alt"></i>
                <span class="badge-notify" v-if="eventos.length > 0">{{eventos.length}}</span>
            </div>
        </nav>
        <v-dialog v-model="mostrarModalNotificacao" width="400">
            <v-card class="modal-notificacao">
                <h3>{{notificacao.notificacao.titulo}}</h3>
                <div class="modal-notificacao-texto">{{notificacao.notificacao.mensagem}}</div>
                <div class="modal-notificacao-data">
                    Enviada em: <span>{{notificacao.enviada_em | dateTimeEnToBr}}</span>
                </div>
                <div class="modal-notificacao-data" v-if="notificacao.visualizada_em">
                    Visualizada em: <span>{{notificacao.visualizada_em | dateTimeEnToBr}}</span>
                </div>
                <div class="modal-notificacao-data" v-if="notificacao.aberta_em">
                    Aberta em: <span>{{notificacao.aberta_em | dateTimeEnToBr}}</span>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<style lang="scss">

    .notificacoes-card {
        .notificacoes-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 15px;
            background-color: #F1F3EA;
            line-height: 38px;
            position: relative;
            z-index: 20;
            box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
            .notificacoes-header-title {
                color: #5c7d6f;
            }
            .notificacoes-header-icon {
                color: #5d5d5d;
                cursor: pointer;
            }
        }
        .notificacoes-todos {
            position: relative;
            z-index: 20;
            box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.1);
            display: block;
            text-decoration: none;
            background-color: #8ba686;
            line-height: 40px;
            text-align: center;
            color: #FFF;
            font-size: 13px;
            font-weight: bold;
            text-transform: uppercase;
        }
    }

    .notificacoes-lista {
        max-height: 385px;
        overflow: auto;

        .notificacoes-lista-item {
            position: relative;
            .item-lista-remover {
                position: absolute;
                right: 10px;
                top: 5px;
                text-align: center;
                color: #b1b1b1;
            }
        }
    }

    .notificacoes-item-visualizado {
        background-color: #f2f2f2;
    }

    .notificacoes-card-text {
        font-size: 12px;
        line-height: 16px;
        color: #717171;
    }

    .notificacoes-lista-vazia {
        font-size: 13px;
        line-height: 18px;
        color: #717171;
        padding: 20px;
    }

    .modal-notificacao {
        padding: 20px;
        h3 {
            margin: 0;
            padding: 0 0 15px;
            font-weight: 400;
            font-size: 22px;
            color: #3c3c3c;
        }
        .modal-notificacao-texto {
            font-size: 16px;
            line-height: 24px;
            color: #646464;
            padding-bottom: 15px;
        }
        .modal-notificacao-data {
            font-size: 13px;
            line-height: 18px;
            color: #2b2b2b;
            font-weight: 500;
            padding-top: 5px;
        }
    }
</style>



// WEBPACK FOOTER //
// Notificacoes.vue?03477fad